"use client";

import { useEffect } from "react";

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element | null, reload: boolean) => void;
    };
  }
}

interface ITrustpilotWidgetProps {
  style?: React.CSSProperties; // Optional inline styles
}
const TrustpilotWidget = ({
  style = {},
}: ITrustpilotWidgetProps): JSX.Element => {
  useEffect(() => {
    // Try loading the widget if the script is already loaded
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(
        document.querySelector(".trustpilot-widget-footer"),
        true
      );
    }

    const scriptId = "trustpilot-script";

    // Only inject script if it doesn't already exist
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src =
        "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.id = scriptId;

      script.onload = () => {
        window.Trustpilot?.loadFromElement(
          document.querySelector(".trustpilot-widget-footer"),
          true
        );
      };

      document.body.appendChild(script);
    }
  }, []);

  return (
    <div
      className="trustpilot-widget trustpilot-widget-footer d-flex justify-content-center"
      data-locale="en-GB"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="600359c87a637900014237da"
      data-style-height="120px"
      data-style-width="60%"
      style={{ ...style }}
    >
      <a
        href="https://uk.trustpilot.com/review/www.mygwork.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotWidget;
